import type { SearchModes } from '@/domainLogic/index.ts';

export enum SEARCH_TYPE {
  DESTINATIONS = 'DESTINATIONS',
  PRODUCTS = 'PRODUCTS',
}

export enum ORIGIN_TYPE {
  AIRPORT = 'AIRPORT',
  AIRPORT_GROUP = 'AIRPORT_GROUP',
  TRAIN_STATION = 'TRAIN_STATION',
}

export enum DESTINATION_TYPE {
  AIRPORT = 'AIRPORT',
  ANYWHERE = 'ANYWHERE',
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  GEO = 'GEO',
  LEISURE = 'LEISURE',
  TAG = 'TAG',
  TRAIN_STATION = 'TRAIN_STATION',
}

type SearchInfoOrigin = {
  id: string;
  cityId: string;
  type: ORIGIN_TYPE | undefined;
  description: string;
};

export type SearchInfoCoordinate = {
  lat?: number;
  lng?: number;
};
type SearchInfoDestination = {
  id: string;
  geodbId?: string;
  destinationType: DESTINATION_TYPE | undefined;
  cityName: string;
  countryCode: string;
  countryName: string;
  description: string;
  descriptionLong: string;
  coordinates?: SearchInfoCoordinate[];
  manageable: boolean;
};

export type SearchInfoData = {
  searchType: SEARCH_TYPE;
  searchId: string;
  searchMode: SearchModes;
  isLiveSearch: boolean;
  searchTraceId: string;
  searchTraceParent: string;
};

export type SearchInfoDetailData = {
  origin: SearchInfoOrigin;
  destination: SearchInfoDestination;
};
